import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared.module';
import { DrugAllergyComponent } from './drug-allergy/drug-allergy.component';
import { PatientRemarkDialogComponent } from './patient-remark-dialog/patient-remark-dialog.component';

const PATIENT_CLINICAL_COMPONENTS = [
  DrugAllergyComponent,
  PatientRemarkDialogComponent
];

@NgModule({
  declarations: PATIENT_CLINICAL_COMPONENTS,
  imports: [SharedModule],
  exports: PATIENT_CLINICAL_COMPONENTS
})
export class PatientClinicalSharedModule { }
